// infcode_change - metrics foundation
import { InstallationVersion } from "@opencode-ai/core/installation/version"
import cliPkg from "../../../package.json" with { type: "json" }

const PREVIEW_INSTALLATION = /^0\.0\.0-/

function isPluginHost(platform: string | undefined) {
  return platform === "vscode" || platform === "jetbrains" || platform === "ide"
}

function resolveCliVersion(): string {
  // 正式 release 构建：InstallationVersion 即 CLI 产物版本（如 7.2.52）
  if (InstallationVersion !== "local" && !PREVIEW_INSTALLATION.test(InstallationVersion)) {
    return InstallationVersion
  }
  // 本地/预览构建：不用 0.0.0-feat-* 分支 stamp，回落到 package.json 语义版本
  return cliPkg.version
}

function resolvePluginVersion(): string {
  // VS Code / JetBrains 启动 CLI 时注入宿主插件版本（见 server-manager / KiloBackendCliManager）
  return process.env["KILO_APP_VERSION"]?.trim() || "unknown"
}

/** 上报 version：插件宿主用插件版本，纯 CLI 用 CLI 版本，互不混用。 */
export function resolveMetricsVersion(): string {
  const platform = process.env["INFCODE_PLATFORM"]
  if (isPluginHost(platform)) return resolvePluginVersion()
  return resolveCliVersion()
}
